"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const { convertPointToTurfPosition, getThingInArea } = datamodel_core_1.TurfUtils;
const typeName = 'Field';
class Field extends datamodel_core_1.Area {
    constructor(ob) {
        super({ ...ob, type: typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of the Zone eg south field',
            },
            functions: {
                type: 'Derived',
                valueFn: (state, functions, accessKey) => {
                    return { state, functions, accessKey, thisObject: this };
                },
                viewName: 'UIThingFunctions',
            },
            Location: {
                type: 'Derived',
                valueFn: (state, functions) => {
                    const pointArr = convertPointToTurfPosition === null || convertPointToTurfPosition === void 0 ? void 0 : convertPointToTurfPosition(this.position);
                    const field = state.userView ? getThingInArea === null || getThingInArea === void 0 ? void 0 : getThingInArea(state.userView, pointArr) : undefined;
                    return {
                        thing: this,
                        position: this.position,
                        field,
                    };
                },
                viewName: 'FieldDetails',
            },
            History_Charts: {
                type: 'Derived',
                actions: {
                    create: false,
                    link: false,
                },
                valueFn: () => {
                    return { currentThingHistory: this.history };
                },
                viewName: 'ThingHistoryCharts',
            },
            Device: {
                type: 'Array',
                label: 'Monitoring Devices',
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        };
    }
    getLinkAttributes() {
        const functions = this.getUserAttributes().functions;
        return {
            ...super.getLinkAttributes(),
            functions,
        };
    }
}
exports.Field = Field;
